export const WIDTH = 'Width';
export const HEIGHT = 'Height';
export const DEPTH = 'Depth';
